export const testimonials = [
  {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Buenos Aires',
    role: 'Profesora de HIIT',
    text: 'Antes llegaba al domingo sin saber qué dar el lunes. Ahora tengo las 6 clases de la semana listas en 10 minutos. El grupo lo notó inmediatamente.',
  },
  {
    initials: 'MT',
    name: 'Marcos T.',
    location: 'Rosario',
    role: 'Instructor HIIT — 4 turnos',
    text: 'El Tomo 4 me cambió el nivel. Los alumnos empezaron a preguntar qué protocolo íbamos a hacer. Nunca había pasado eso.',
  },
  {
    initials: 'CF',
    name: 'Carolina F.',
    location: 'Córdoba',
    role: 'Profesora de HIIT y Funcional',
    text: 'Lo del Gran Desafío del Tomo 5 fue increíble. El grupo habló de esa clase durante semanas. Tres alumnos trajeron amigos.',
  },
]

export const moreTestimonials = [
  {
    initials: 'VR',
    name: 'Valeria R.',
    age: 32,
    location: 'Buenos Aires',
    role: 'Profesora de HIIT · 6 años en turnos grupales',
    text: 'Antes llegaba al domingo sin saber qué dar el lunes. Ahora tengo las 6 clases de la semana listas en 10 minutos. El grupo lo notó al toque: vienen más motivados, faltan menos. Recuperé mi domingo y el turno se llenó.',
  },
  {
    initials: 'MT',
    name: 'Marcos T.',
    age: 38,
    location: 'Rosario',
    role: 'Instructor HIIT · 4 turnos semanales',
    text: 'El Tomo 4 me cambió completamente el nivel. Sprint Intervals y EPOC Training son una bomba: los alumnos empezaron a preguntar qué protocolo íbamos a hacer la próxima. Nunca me había pasado eso en 8 años dando clases.',
  },
  {
    initials: 'CF',
    name: 'Carolina F.',
    age: 29,
    location: 'Córdoba',
    role: 'Profesora HIIT y Funcional · 5 años',
    text: 'El Gran Desafío del Tomo 5 fue una locura. El grupo habló de esa clase durante semanas y tres alumnos trajeron amigos al turno siguiente. Por primera vez sentí que tenía un sistema real y no rutinas sueltas.',
  },
  {
    initials: 'AM',
    name: 'Agustín M.',
    age: 41,
    location: 'Mendoza',
    role: 'Profesor HIIT · Gimnasio propio',
    text: 'Compré el combo con Turnos Llenos. En 6 semanas subí la cuota un 30%, llené el turno del mediodía que tenía a medias y recuperé 3 ex-alumnos con los guiones de WhatsApp. La inversión se pagó sola en la primera semana.',
  },
  {
    initials: 'DK',
    name: 'Daniela K.',
    age: 35,
    location: 'La Plata',
    role: 'Instructora HIIT · 3 turnos en box',
    text: 'Lo que más me sirvió fue el Banco de Bloques HIIT para combinar. Armo clases nuevas en 5 minutos y nunca repito. Mis alumnos me dicen que cada clase los sorprende. Eso antes era imposible.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Cimientos y Adaptación',
    months: 'Semanas 1-8',
    content:
      'La base que todo grupo necesita. Técnica, hábito y confianza desde la primera clase. Patrones funcionales, control respiratorio y activación progresiva para preparar al grupo al alto rendimiento.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Resistencia Metabólica',
    months: 'Semanas 9-16',
    content:
      'AMRAP, EMOM, Tabata doble y circuitos de alta densidad. El bloque que construye resistencia real y eleva el VO2 max del grupo semana a semana.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Fuerza y Potencia',
    months: 'Semanas 17-24',
    content:
      'Tempo training, contraste fuerza-potencia y pliometría progresiva. Donde los cuerpos cambian: más explosividad, más tono, más resultados visibles.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'HIIT Quema-Grasa Extremo',
    months: 'Semanas 25-32',
    content:
      'EPOC Training, Sprint Intervals y Tabata Extremo. El tomo más intenso del sistema. Pensado para acelerar resultados estéticos y de rendimiento.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Tabatas y Protocolos Especiales',
    months: 'Semanas 33-40',
    content:
      'Tabata científico, Gibala Protocol, BPM Method y El Gran Desafío del Año: la clase que tu grupo va a recordar para siempre.',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Retención, Nutrición y Cierre de Año',
    months: 'Semanas 41-52',
    content:
      'La clase de cierre que fideliza, la evaluación final medible y el sistema de renovación para que tu grupo se inscriba al próximo ciclo sin dudarlo.',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '⚡',
    name: 'Kit Express de Clases Imprevistas',
    desc: '12 clases listas para cuando no llegaste a planificar. Imprimís y das.',
    value: '$9.900',
  },
  {
    id: '02',
    icon: '🧱',
    name: 'Banco de Bloques HIIT para Combinar',
    desc: '30 bloques modulares para crear clases nuevas en minutos sin repetirte.',
    value: '$8.500',
  },
  {
    id: '03',
    icon: '✅',
    name: 'Checklist Maestra del Profe HIIT Pro',
    desc: '15 checklists para entrar a cada clase con control total.',
    value: '$7.500',
  },
  {
    id: '04',
    icon: '🎯',
    name: 'Guía de Variantes por Nivel',
    desc: '24 ejercicios con versión básica, media y avanzada para grupos mixtos.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '🎤',
    name: '50 Aperturas y Cierres de Clase',
    desc: 'Para sonar profesional en cada turno sin repetirte una sola vez.',
    value: '$6.500',
  },
  {
    id: '06',
    icon: '📅',
    name: 'Planificador Semanal Listo para Imprimir',
    desc: 'Organizá toda la semana en 10 minutos el domingo. Sin estrés.',
    value: '$5.500',
  },
]

export const faqs = [
  {
    q: '¿Sirve para cualquier tipo de grupo?',
    a: 'Sí. Tiene variantes para principiantes, intermedios y avanzados. Funciona para grupos mixtos y turnos de distintos niveles.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Por email, en menos de 5 minutos después de tu compra. Disponible en celular, computadora o tablet. Para siempre.',
  },
  {
    q: '¿Qué lo diferencia de lo que hay gratis en Instagram?',
    a: 'El contenido de Instagram son rutinas sueltas. Este es un sistema de 52 semanas con progresión real y periodización científica. No es lo mismo buscar ejercicios sueltos que tener el año resuelto.',
  },
  {
    q: '¿Sirve si doy HIIT en un espacio pequeño o sin equipamiento?',
    a: 'Sí. La mayoría de las clases no necesitan implementos. Las que los usan requieren solo una silla, mochila o banda elástica. Pensado para la realidad del profe argentino.',
  },
  {
    q: '¿Hay mensualidad o suscripción?',
    a: 'No. Pago único. El material es tuyo para siempre, lo descargás y lo usás todas las veces que quieras.',
  },
  {
    q: '¿La garantía es real?',
    a: 'Absolutamente. Escribís a compradigitalyaa@gmail.com y te devolvemos el 100%. Sin formularios, sin vueltas. Menos del 1% de los profes la usa.',
  },
  {
    q: '¿Puedo usarlo en varios turnos?',
    a: 'Sí. Sin límite de uso. Lo aplicás en todos tus turnos, grupos y horarios.',
  },
  {
    q: '¿Qué medios de pago aceptan?',
    a: 'Mercado Pago, tarjeta de débito y crédito, transferencia bancaria y todos los medios disponibles en el checkout.',
  },
  {
    q: '¿Funciona si recién empiezo como profe de HIIT?',
    a: 'Sí. El Tomo 1 (Cimientos y Adaptación) está pensado para arrancar desde cero. Te da estructura, técnica y seguridad para pararte frente al grupo desde el primer día.',
  },
  {
    q: '¿Puedo usarlo si combino HIIT con otras modalidades (funcional, cross)?',
    a: 'Sí. Los bloques y protocolos se integran perfecto con entrenamiento funcional, cross o circuitos. Muchos profes lo usan como base para todos sus turnos grupales.',
  },
]

export const purchaseNotifications = [
  { name: 'Valeria R.', city: 'Buenos Aires', plan: 'Combo Completo HIIT Pro' },
  { name: 'Marcos T.', city: 'Rosario', plan: 'Combo + Turnos Llenos' },
  { name: 'Carolina F.', city: 'Córdoba', plan: 'Combo Completo HIIT Pro' },
  { name: 'Agustín M.', city: 'Mendoza', plan: 'Combo + Turnos Llenos' },
  { name: 'Daniela K.', city: 'La Plata', plan: 'Combo Completo HIIT Pro' },
  { name: 'Federico G.', city: 'Mar del Plata', plan: 'Combo + Turnos Llenos' },
  { name: 'Lucía S.', city: 'Salta', plan: 'Combo Completo HIIT Pro' },
  { name: 'Nicolás P.', city: 'Tucumán', plan: 'Combo + Turnos Llenos' },
  { name: 'Romina V.', city: 'Neuquén', plan: 'Combo Completo HIIT Pro' },
  { name: 'Sebastián L.', city: 'Bahía Blanca', plan: 'Combo + Turnos Llenos' },
]
